export const startWallet = new Date('2025-12-01T00:00:00')
export const startExchange = new Date('2026-03-01T00:00:00')
export const startOrg = new Date('2026-06-01T00:00:00')

export const API_URL = process.env.REACT_APP_API_URL || '/api/v1/web/'
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || '/media/'
